
   import { defineComponent } from "vue";
   import { deleteAuthToken, getAuthToken } from "@/security";
   import { Contact } from "@/ApiInterfaces";


   interface CmsHeaderData {
      contact: Contact | null
   }

   export default defineComponent({
      name: "PublicHeader",
      data(): CmsHeaderData {
         return {
            contact: null
         }
      },
      created() {
         this.getContact();
      },
      methods: {
         getContact() {
            var token = getAuthToken();

            if (token) {
               try {
                  fetch(
                     `/api/contact`,
                     {
                        headers: {
                           "X-DT-TOKEN": token
                        }
                     }
                  )
                  .then((r) => {
                     if (r.ok) {
                        r.json()
                           .then((json) => {
                              this.contact = json as Contact;
                              return;
                           })
                           .catch((e) => {
                              console.error(e.toString());
                              window.location.href = '/CMS/Login';
                           });
                     } else {
                        // Contact not found so go to the login page
                        window.location.href = '/CMS/Login';
                     }
                  })
                  .catch((e) => {
                     console.error(e.toString());
                     window.location.href = '/CMS/Login';
                  });
               } catch (e) {
                  console.error(e.toString());
                  window.location.href = '/CMS/Login';
               }
            }
         },
         logout() {
            var token = getAuthToken();

            deleteAuthToken();

            if (token) {
               try {
                  fetch(
                     `/api/contacttokens/deauthenticate`,
                     {
                        method: "post",
                        headers: {
                           "X-DT-TOKEN": token
                        }
                     }
                  )
                     .then((r) => {
                        window.location.href = '/CMS/Logout';
                     })
                     .catch((e) => {
                        console.error(e.toString());
                        window.location.href = '/CMS/Logout';
                     });
               } catch (e) {
                  console.error(e.toString());
                  window.location.href = '/CMS/Logout';
               }
            } else {
               window.location.href = '/CMS/Logout';
            }
         }
      }
   });
